import React, { Fragment, useEffect } from "react";
import { filter, find, includes, orderBy, toLower } from "lodash";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay, Navigation } from "swiper/modules";
import { useMediaQuery } from "react-responsive";
import {
  Box,
  Grid,
  Paper,
  Typography,
  Tooltip,
  Container,
} from "@mui/material";
import { useNavigate } from "react-router-dom";
import { COLORS } from "../../constants";
import useSystemHook from "./../../hooks/SystemHook";

const VendorSlider = ({ vendors }) => {
  const navigate = useNavigate();
  const { isMobile, isTablet, isDesktop } = useSystemHook();
  const [vendorsToDisplay, setVendorsToDisplay] = React.useState([]);
  const staticVendorOrder = [
    { vendor: "m7", vendorOrder: 1 },
    { vendor: "flight", vendorOrder: 2 },
    { vendor: "doe", vendorOrder: 3 },
    { vendor: "x-appeal", vendorOrder: 4 },
    { vendor: "beta", vendorOrder: 5 },
    { vendor: "ngk", vendorOrder: 6 },
    { vendor: "kyb", vendorOrder: 7 },
    { vendor: "fram", vendorOrder: 8 },
    { vendor: "shield", vendorOrder: 9 },
    { vendor: "q20", vendorOrder: 10 },
    { vendor: "ate", vendorOrder: 11 },
    { vendor: "optima", vendorOrder: 12 },
    { vendor: "teknosa", vendorOrder: 13 },
  ];

  const onVendorClick = (vendor) => {
    navigate(`/products/all?vendor=${vendor.vendorId}`);
  };

  const capitalize = (input) => {
    return input
      .toLowerCase()
      .split(" ")
      .map((s) => s.charAt(0).toUpperCase() + s.substring(1))
      .join(" ");
  };

  useEffect(() => {
    if (!!vendors) {
      const vendorNames = staticVendorOrder.map((v) => v.vendor);
      const filteredVendors = filter(vendors, (v) =>
        includes(vendorNames, v.name.replaceAll(" ", "_").toLowerCase())
      );
      const filteredVendorsWithOrder = filteredVendors.map((v) => {
        const staticVendor = find(
          staticVendorOrder,
          (s) => toLower(s.vendor) === toLower(v.name.replaceAll(" ", "_"))
        );
        return { ...v, order: staticVendor.vendorOrder };
      });
      const orderedVendors = orderBy(filteredVendorsWithOrder, (v) => v.order);
      setVendorsToDisplay(orderedVendors);
    }
  }, [vendors]);

  return (
    <Fragment>
      {isMobile === false && (
        <Container maxWidth="lg" disableGutters>
          <Box sx={{ mt: 10, p: 1 }}>
            <Typography
              variant={!isMobile ? "h6" : ""}
              fontFamily="Rubik"
              gutterBottom
              color={COLORS.darkText}
              sx={{ display: "inline", textTransform: "uppercase" }}
            >
              <span style={{ fontWeight: 500 }}>Featured</span>{" "}
              <span style={{ fontWeight: 200 }}>Brands</span>
            </Typography>

            <Box sx={{ mt: 4, mb: 4 }}>
              <Swiper
                modules={[Autoplay, Navigation]}
                spaceBetween={isTablet ? 70 : -70} // Match CategorySlider desktop spacing
                slidesPerView={5} // Match CategorySlider desktop slidesPerView
                navigation
                loop={true}
                autoplay={{
                  delay: 5000,
                  disableOnInteraction: true,
                }}
                sx={{}}
              >
                {vendorsToDisplay.map((vendor, index) => {
                  const vendorName = capitalize(
                    vendor.name.replaceAll("_", "")
                  );
                  return (
                    <SwiperSlide
                      key={index}
                      style={{
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                      }}
                    >
                      <a
                        href={`/products/all?vendor=${vendor.vendorId}`}
                      >
                        <Tooltip
                          title={vendor.description}
                          arrow
                          placement="top"
                        >
                          <img
                            src={vendor.image}
                            alt={vendorName}
                            style={{
                              height: "7rem",
                              width: "7rem",
                              margin: 0,
                            }}
                          />
                        </Tooltip>
                      </a>
                    </SwiperSlide>
                  );
                })}
              </Swiper>
            </Box>
          </Box>
        </Container>
      )}
      {isMobile === true && (
        <>
          <Box sx={{ mt: 2, p: 2, mb: 2 }}>
            <Typography
              variant={!isMobile ? "h6" : ""}
              fontFamily="Rubik"
              gutterBottom
              color={COLORS.darkText}
              sx={{ display: "inline", textTransform: "uppercase" }}
            >
              <span style={{ fontWeight: 500 }}>Featured</span>{" "}
              <span style={{ fontWeight: 200 }}>Brands</span>
            </Typography>
          </Box>
          <section>
            <Swiper
              modules={[Autoplay, Navigation]}
              spaceBetween={10}
              slidesPerView={3}
              loop={true}
              autoplay={{
                delay: 3000,
                disableOnInteraction: true,
              }}
              navigation
              grabCursor={true}
            >
              {vendorsToDisplay.map((vendor, index) => {
                const vendorName = capitalize(
                  vendor.name.replaceAll("_", "")
                );
                return (
                  <SwiperSlide
                    key={index}
                    style={{
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                    }}
                  >
                    <a
                      href={`/products/all?vendor=${vendor.vendorId}`}
                    >
                      <Tooltip
                        title={vendor.description}
                        arrow
                        placement="top"
                      >
                        <img
                          src={vendor.image}
                          alt={vendorName}
                          style={{
                            height: "5.5rem",
                            width: "5.5rem",
                            margin: 0,
                          }}
                        />
                      </Tooltip>
                    </a>
                  </SwiperSlide>
                );
              })}
            </Swiper>
          </section>
          <Box sx={{ mb: 4 }} />
        </>
      )}
    </Fragment>
  );
};

export default VendorSlider;
